// Client-side mirrors of the DB's generated `shares` / `equity_pct`
// columns. Used wherever the UI needs to reflect an edit instantly
// rather than waiting for a save + refetch.

export const SHARE_POOL = 10_000_000

export const SHARE_CLASS_ADVISOR = 'advisor'
export const SHARE_CLASS_OPTIONS = [
  { value: 'A', text: 'A' },
  { value: 'B', text: 'B' },
  { value: 'C', text: 'C' },
  { value: 'Preferred', text: 'Preferred' },
  { value: 'Common', text: 'Common' },
  { value: SHARE_CLASS_ADVISOR, text: 'Advisor' }
]

// Build valuation options from root.valuations for the origin_valuation
// dropdown. Falls back to hardcoded rounds if DB hasn't loaded yet.
export const valuationOptions = (root) => {
  const rows = root?.valuations
  if (rows?.length) {
    return rows.map(r => ({
      value: String(r.amount),
      text: `${r.label} — $${Number(r.amount).toLocaleString()}`
    }))
  }
  return [
    { value: '1250000', text: 'Bootstrap 1 — $1,250,000' },
    { value: '2500000', text: 'Bootstrap 2 — $2,500,000' },
    { value: '12000000', text: 'Bootstrap 3 — $12,000,000' },
    { value: '15000000', text: 'Pre-seed — $15,000,000' }
  ]
}

export const liveShares = (g) => {
  if (g?.shares_manual != null) return Number(g.shares_manual)
  const ov = Number(g?.origin_valuation) || 0
  const mo = Number(g?.salary_monthly) || 0
  if (!ov || !mo || !g?.vesting_start || !g?.vesting_end) return Number(g?.shares) || 0
  const months = (new Date(g.vesting_end) - new Date(g.vesting_start)) / (1000 * 60 * 60 * 24 * 30.4375)
  if (months <= 0) return Number(g?.shares) || 0
  return Math.round(mo * months / ov * SHARE_POOL)
}

export const liveEquityPct = (g) => {
  const s = liveShares(g)
  return s ? (s / SHARE_POOL) * 100 : 0
}
